import { Button, Icon } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import Typography from '@material-ui/core/Typography';
import { motion } from 'framer-motion';
import { useFormContext } from 'react-hook-form';
import { useHistory, Link } from 'react-router-dom';
import _ from '@lodash';
import { useEditForm } from 'modules/ui/editform/EditFormProvider';

function EditFormHeader(props) {
	const { setSaveBtnKeyClick } = useEditForm();
	const { t } = useTranslation(props.config.topic ? ['editform', props.config.topic] : 'editform');
	const methods = useFormContext();
	const { watch } = methods;
	const name = watch(_.isUndefined(props.config.watchTitleKey) ? 'name' : props.config.watchTitleKey);
	const theme = useTheme();
	const history = useHistory();

	return (
		<div className="flex flex-1 w-full items-center justify-between">
			<div className="flex flex-col items-start max-w-full min-w-0">
				{!(_.isBoolean(props.config.hideBackLink) && props.config.hideBackLink) ? (
					<motion.div initial={{ x: 20, opacity: 0 }} animate={{ x: 0, opacity: 1, transition: { delay: 0.3 } }}>
						{_.isFunction(props.config.backLink) ? (
							<Typography className="flex items-center sm:mb-12" component={Link} role="button" to={() => props.config.backLink()} color="inherit">
								<Icon className="text-20">{theme.direction === 'ltr' ? 'arrow_back' : 'arrow_forward'}</Icon>
								<span className="hidden sm:flex mx-4 font-medium">{t('BACK')}</span>
							</Typography>
						) : (
							<Typography className="flex items-center sm:mb-12" component={Button} role="button" onClick={() => history.goBack(history)} color="inherit">
								<Icon className="text-20">{theme.direction === 'ltr' ? 'arrow_back' : 'arrow_forward'}</Icon>
								<span className="hidden sm:flex mx-4 font-medium">{t('BACK')}</span>
							</Typography>
						)}
					</motion.div>
				) : null}

				<div className="flex items-center max-w-full">
					<div className="flex flex-col min-w-0 mx-8 sm:mc-16">
						<motion.div initial={{ x: -20 }} animate={{ x: 0, transition: { delay: 0.3 } }}>
							<Typography className="text-16 sm:text-20 truncate font-semibold">
								{_.isFunction(props.config.title) ? props.config.title(props.data) : name || `${t('NEW')} ${!_.isUndefined(props.config.text) ? props.config.text : t(`${props.config.topic}:${props.config.key}`)}`}
							</Typography>
							<Typography variant="caption" className="font-medium">
								{_.isFunction(props.config.description)
									? props.data
										? props.config.description(props.data)
										: ''
									: `${!_.isUndefined(props.config.text) ? props.config.text : t(`${props.config.topic}:${props.config.key}`)} ${t('DETAILS')}`}
							</Typography>
						</motion.div>
					</div>
				</div>
			</div>
			<motion.div className="flex" initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0, transition: { delay: 0.3 } }}>
				{props.config.otherSaveButtonList
					? props.config.otherSaveButtonList.map(btn =>
							btn.place === 'before' && (!_.isFunction(btn.visibleIf) || (props.data && btn.visibleIf(props.data))) ? (
								<Button
									key={btn.key}
									className="whitespace-nowrap mx-4"
									variant="contained"
									color={btn.color ? btn.color : 'secondary'}
									onClick={() =>
										_.isFunction(btn.action) ? btn.action() : _.isBoolean(btn.ignoreSaveMethod) && btn.ignoreSaveMethod === true ? history.push(btn.link(props.data)) : setSaveBtnKeyClick({ btnKey: btn.key })
									}
									startIcon={<Icon className="hidden sm:flex">{btn.icon}</Icon>}
								>
									{`${!_.isUndefined(btn.text) ? btn.text : t(`${props.config.topic}:${btn.key}`)}`}
								</Button>
							) : null
					  )
					: null}
				{!(_.isBoolean(props.config.hideSaveButton) && props.config.hideSaveButton) ? (
					<Button className="whitespace-nowrap mx-4" variant="contained" color="secondary" onClick={() => setSaveBtnKeyClick({ btnKey: 'default' })} startIcon={<Icon className="hidden sm:flex">save</Icon>}>
						{t('SAVE')}
					</Button>
				) : null}
				{props.config.otherSaveButtonList
					? props.config.otherSaveButtonList.map(btn =>
							btn.place === 'after' && (!_.isFunction(btn.visibleIf) || (props.data && btn.visibleIf(props.data))) ? (
								<Button
									key={btn.key}
									className="whitespace-nowrap mx-4"
									variant="contained"
									color={btn.color ? btn.color : 'secondary'}
									onClick={() =>
										_.isFunction(btn.action) ? btn.action() : _.isBoolean(btn.ignoreSaveMethod) && btn.ignoreSaveMethod === true ? history.push(btn.link(props.data)) : setSaveBtnKeyClick({ btnKey: btn.key })
									}
									startIcon={<Icon className="hidden sm:flex">{btn.icon}</Icon>}
								>
									{`${!_.isUndefined(btn.text) ? btn.text : t(`${props.config.topic}:${btn.key}`)}`}
								</Button>
							) : null
					  )
					: null}
			</motion.div>
		</div>
	);
}

export default EditFormHeader;
